module.exports = __webpack_public_path__ + "img/uber-d.8d01db48.svg";